
export const environment = {
  production: true,
  // url: 'https://psa-dev.kcmsecurity.eu/stcai-datasetcreationapi/',
  url: 'https://datacreationtool.procit.com/nodeapi/'
};



